import { palette } from '../palette';
import baseTheme from '../baseTheme';
export var MuiTableCell = {
    head: {
        color: palette.text.primary,
        fontSize: baseTheme.typography.h5.fontSize,
        fontWeight: baseTheme.typography.h5.fontWeight,
        whiteSpace: 'nowrap',
        borderRight: 0,
        borderBottom: "1px solid " + baseTheme.palette.grey[300],
        '&$sizeSmall': {
            fontSize: baseTheme.typography.h6.fontSize,
            fontWeight: baseTheme.typography.h6.fontWeight,
        },
    },
    root: {
        whiteSpace: 'nowrap',
        borderBottom: 'none',
        fontSize: baseTheme.typography.body1.fontSize,
        fontWeight: baseTheme.typography.body1.fontWeight,
        padding: baseTheme.spacing(1, 2),
        lineHeight: '1.5rem',
        '&$sizeSmall': {
            fontSize: baseTheme.typography.body2.fontSize,
            fontWeight: baseTheme.typography.body2.fontWeight,
            padding: baseTheme.spacing(0.25, 2),
        },
    },
};
//# sourceMappingURL=MuiTableCell.js.map